import React from "react";
import { Badge, Tag } from "antd";

export type BadgeStatus =
  | "success"
  | "error"
  | "warning"
  | "processing"
  | "default";

interface StatusBadgeProps {
  status: BadgeStatus;
  text: string;
  type?: "badge" | "tag";
  tagColor?: string;
}

export default function StatusBadge({
  status,
  text,
  type = "badge",
  tagColor,
}: StatusBadgeProps) {
  if (type === "tag") {
    return (
      <Tag color={tagColor || status} variant="outlined">
        {text}
      </Tag>
    );
  }
  return <Badge status={status} text={text} />;
}
